import { render, staticRenderFns } from "./BigCourseItem.vue?vue&type=template&id=21510f0f&scoped=true&"
import script from "./BigCourseItem.vue?vue&type=script&lang=js&"
export * from "./BigCourseItem.vue?vue&type=script&lang=js&"
import style0 from "./BigCourseItem.vue?vue&type=style&index=0&id=21510f0f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21510f0f",
  null
  
)

export default component.exports